/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Partial_ErrorInputs */

const en_matching_score_partial_error = /** @type {(inputs: Matching_Score_Partial_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some scores could not be calculated.`)
};

const de_matching_score_partial_error = /** @type {(inputs: Matching_Score_Partial_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige Scores konnten nicht berechnet werden.`)
};

/**
* | output |
* | --- |
* | "Some scores could not be calculated." |
*
* @param {Matching_Score_Partial_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_partial_error = /** @type {((inputs?: Matching_Score_Partial_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Partial_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_partial_error(inputs)
	return en_matching_score_partial_error(inputs)
});